export const OFFBOARDING = {
  employmentMissing: 'OFFBOARD_EMPLOYMENT_MISSING',
  base: '/common/offboarding', permissions: '/permissions', options: '/options',
  cases: '/cases', search: '/cases/search', actions: '/actions', employees: '/employees/',
  archive: '/archive', assignments: '/assignments', revoke: '/revoke',
  importAudits: '/archive/imports',
  importAll: '/archive/import-all', importRunning: 'RUNNING', importFailed: 'FAILED', importPollMs: 2000,
  archiveDrawerClass: 'offboarding-archive-drawer',
  query: 'query', offset: 'offset', limit: 'limit', limitValue: 30, queryMin: 2,
  targetEmployeeId: 'targetEmployeeId', function: 'function',
  caseId: 'caseId', assignmentId: 'assignmentId', successors: 'successors', replace: '/replace',
  v2: 'V2', addNote: 'ADD_NOTE', returnToCeo: 'RETURN_TO_CEO',
  locationCode: 'locationCode',
  confirmation: 'CONFIRMATION', number: 'NONNEGATIVE_NUMBER', badge: 'BADGE', replacementReview: 'REPLACEMENT_REVIEW',
  assetReturn: 'ASSET_RETURN', clothingReturn: 'CLOTHING_RETURN', clothingStage: 'CLOTHING_RECEIVER',
  collectionVersion: 3, payrollStage: 'PAYROLL',
  financialResolution: 'FINANCIAL',
  lateIssuedBlocker: 'offboarding.collection.lateIssued',
  collectionItems: '/items/', assetReceipt: '/return-asset', clothingReceipt: '/return-clothing',
  collectionPrefix: 'offboarding.collection.', openServiceAccess: 'OPEN_SERVICE_ACCESS',
  headStage: 'HEAD', ceoStage: 'CEO_REVIEW', stageQuery: 'stage', noteMax: 2000,
  entry: '/entry', returnPermissions: '/return-permissions', start: 'start',
  returnClothing: '/return-clothing',
  route: '/dashboard/offboarding', newRoute: '/dashboard/offboarding/new',
  internal: 'INTERNAL', planfix: 'PLANFIX', mine: 'MINE', all: 'ALL', history: 'HISTORY',
  confirm: 'CONFIRM',
  proposeDates: 'PROPOSE_DATES', hrDates: 'HR_APPROVE_DATES', ceoDates: 'CEO_APPROVE_DATES',
  rejectDates: 'REJECT_DATES', reconcileOrg: 'RECONCILE_ORGANIZATION',
  ceoApprove: 'CEO_APPROVE', reject: 'REJECT', cancel: 'CANCEL', finalize: 'FINALIZE',
  draft: 'DRAFT', hr: 'HR_REVIEW', ceo: 'CEO_REVIEW', executing: 'EXECUTING',
  finalizing: 'FINALIZING', completed: 'COMPLETED', cancelled: 'CANCELLED',
  defaultZone: 'Europe/Minsk', utcSuffix: 'Z', secondsSuffix: ':00Z',
  id: 'id', employeeId: 'employeeId', midnightSuffix: 'T00:00:00Z',
  startError: 'OFFBOARD_INVALID_CUTOFF', revoked: 'REVOKED', functionDefault: 'ASSET_CUSTODIAN', separator: ', '
};
export const OFFBOARDING_FUNCTIONS = [
  'ASSET_CUSTODIAN', 'SERVICE_OWNER', 'CLOTHING_RECEIVER', 'PAYROLL', 'HR', 'CEO', 'COORDINATOR'
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding.constants.ts